<template>
    <ion-header>
        <ion-toolbar color="light">
            <ion-buttons slot="start">
                <ion-button color="primary" @click="cancel">
                    <ion-icon slot="icon-only" :icon="close"></ion-icon>
                </ion-button>
            </ion-buttons>
            <ion-title>{{ label }}</ion-title>
            <ion-buttons v-if="showCreateButton" slot="end">
                <ion-button color="primary" @click="createItem()">
                    <ion-icon slot="icon-only" :icon="add"></ion-icon>
                </ion-button>
            </ion-buttons>
        </ion-toolbar>
    </ion-header>

    <ion-content>
        <list :inset="true" :field_name="field_name" :show_search="true" :items="items" @open="confirm" @refresh="$emit('refresh')"
            :item_size="50" :no_created_at="true" :truncate="false">
        </list>
    </ion-content>
</template>
<script>
import {
    modalController
} from '@ionic/vue';
import {
    close,
    add
} from 'ionicons/icons';

import List from '@/components/List.vue';
import CreateLocationItemComponent from '../views/location_item_components/Create.vue'

export default {
    props: ['items', 'label', 'field_name', 'showCreateButton', 'location_item_uuid'],
    components: {
        List
    },
    data() {
        return {
            close,
            add
        }
    },
    emits: ['refresh', 'open'],
    created() {

    },
    methods: {
        cancel() {
            return modalController.dismiss(null, 'cancel');
        },
        confirm(item) {
            return modalController.dismiss(item, 'confirm');
        },
        async createItem() {
            const modal = await modalController.create({
                component: CreateLocationItemComponent,
                componentProps: {
                    location_item_uuid: this.location_item_uuid
                },
                initialBreakpoint: 0.50,
                breakpoints: [0.50, 1],
                showBackdrop: true,
            }
            );
            modal.present();

            const { role } = await modal.onWillDismiss();

            if (role == 'confirm') {
                this.$emit('refresh')
            }

        },
    }

}
</script>
<style lang="">
    
</style>
